export const languageCodes = {
  af: { name_english: "Afrikaans", name_native: "Afrikaans" },
  sq: { name_english: "Albanian", name_native: "Shqip" },
  "ar-DZ": {
    name_english: "Arabic (Algeria)",
    name_native: "العربية (الجزائر)",
  },
  "ar-BH": {
    name_english: "Arabic (Bahrain)",
    name_native: "العربية (البحرين)",
  },
  "ar-EG": { name_english: "Arabic (Egypt)", name_native: "العربية (مصر)" },
  "ar-IQ": { name_english: "Arabic (Iraq)", name_native: "العربية (العراق)" },
  "ar-JO": { name_english: "Arabic (Jordan)", name_native: "العربية (الأردن)" },
  "ar-KW": { name_english: "Arabic (Kuwait)", name_native: "العربية (الكويت)" },
  "ar-LB": { name_english: "Arabic (Lebanon)", name_native: "العربية (لبنان)" },
  "ar-LY": { name_english: "Arabic (Libya)", name_native: "العربية (ليبيا)" },
  "ar-MA": {
    name_english: "Arabic (Morocco)",
    name_native: "العربية (المغرب)",
  },
  "ar-OM": { name_english: "Arabic (Oman)", name_native: "العربية (عمان)" },
  "ar-QA": { name_english: "Arabic (Qatar)", name_native: "العربية (قطر)" },
  "ar-SA": {
    name_english: "Arabic (Saudi Arabia)",
    name_native: "العربية (السعودية)",
  },
  "ar-SY": { name_english: "Arabic (Syria)", name_native: "العربية (سوريا)" },
  "ar-TN": { name_english: "Arabic (Tunisia)", name_native: "العربية (تونس)" },
  "ar-AE": {
    name_english: "Arabic (U.A.E.)",
    name_native: "العربية (الإمارات)",
  },
  "ar-YE": { name_english: "Arabic (Yemen)", name_native: "العربية (اليمن)" },
  eu: { name_english: "Basque", name_native: "Euskara" },
  be: { name_english: "Belarusian", name_native: "Беларуская" },
  bg: { name_english: "Bulgarian", name_native: "Български" },
  ca: { name_english: "Catalan", name_native: "Català" },
  "zh-HK": { name_english: "Chinese (Hong Kong)", name_native: "中文 (香港)" },
  "zh-CN": { name_english: "Chinese (PRC)", name_native: "中文 (中国)" },
  "zh-SG": {
    name_english: "Chinese (Singapore)",
    name_native: "中文 (新加坡)",
  },
  "zh-TW": { name_english: "Chinese (Taiwan)", name_native: "中文 (台灣)" },
  hr: { name_english: "Croatian", name_native: "Hrvatski" },
  cs: { name_english: "Czech", name_native: "Čeština" },
  da: { name_english: "Danish", name_native: "Dansk" },
  "nl-BE": {
    name_english: "Dutch (Belgium)",
    name_native: "Nederlands (België)",
  },
  nl: { name_english: "Dutch (Standard)", name_native: "Nederlands" },
  en: { name_english: "English", name_native: "English" },
  "en-AU": {
    name_english: "English (Australia)",
    name_native: "English (Australia)",
  },
  "en-BZ": {
    name_english: "English (Belize)",
    name_native: "English (Belize)",
  },
  "en-CA": {
    name_english: "English (Canada)",
    name_native: "English (Canada)",
  },
  "en-IE": {
    name_english: "English (Ireland)",
    name_native: "English (Ireland)",
  },
  "en-JM": {
    name_english: "English (Jamaica)",
    name_native: "English (Jamaica)",
  },
  "en-NZ": {
    name_english: "English (New Zealand)",
    name_native: "English (New Zealand)",
  },
  "en-ZA": {
    name_english: "English (South Africa)",
    name_native: "English (South Africa)",
  },
  "en-TT": {
    name_english: "English (Trinidad)",
    name_native: "English (Trinidad)",
  },
  "en-GB": {
    name_english: "English (United Kingdom)",
    name_native: "English (United Kingdom)",
  },
  "en-US": {
    name_english: "English (United States)",
    name_native: "English (United States)",
  },
  et: { name_english: "Estonian", name_native: "Eesti" },
  fo: { name_english: "Faeroese", name_native: "Føroyskt" },
  fa: { name_english: "Farsi", name_native: "فارسی" },
  fi: { name_english: "Finnish", name_native: "Suomi" },
  "fr-BE": {
    name_english: "French (Belgium)",
    name_native: "Français (Belgique)",
  },
  "fr-CA": {
    name_english: "French (Canada)",
    name_native: "Français (Canada)",
  },
  "fr-LU": {
    name_english: "French (Luxembourg)",
    name_native: "Français (Luxembourg)",
  },
  fr: { name_english: "French (Standard)", name_native: "Français" },
  "fr-CH": {
    name_english: "French (Switzerland)",
    name_native: "Français (Suisse)",
  },
  gd: { name_english: "Gaelic (Scotland)", name_native: "Gàidhlig (Alba)" },
  "de-AT": {
    name_english: "German (Austria)",
    name_native: "Deutsch (Österreich)",
  },
  "de-LI": {
    name_english: "German (Liechtenstein)",
    name_native: "Deutsch (Liechtenstein)",
  },
  "de-LU": {
    name_english: "German (Luxembourg)",
    name_native: "Deutsch (Luxemburg)",
  },
  de: { name_english: "German (Standard)", name_native: "Deutsch" },
  "de-CH": {
    name_english: "German (Switzerland)",
    name_native: "Schwiizerdütsch",
  }, //"Deutsch (Schweiz)" },
  el: { name_english: "Greek", name_native: "Ελληνικά" },
  he: { name_english: "Hebrew", name_native: "עברית" },
  hi: { name_english: "Hindi", name_native: "हिन्दी" },
  hu: { name_english: "Hungarian", name_native: "Magyar" },
  is: { name_english: "Icelandic", name_native: "Íslenska" },
  id: { name_english: "Indonesian", name_native: "Bahasa Indonesia" },
  ga: { name_english: "Irish", name_native: "Gaeilge" },
  it: { name_english: "Italian (Standard)", name_native: "Italiano" },
  "it-CH": {
    name_english: "Italian (Switzerland)",
    name_native: "Italiano (Svizzera)",
  },
  ja: { name_english: "Japanese", name_native: "日本語" },
  ko: { name_english: "Korean (Johab)", name_native: "한국어" },
  ku: { name_english: "Kurdish", name_native: "Kurdî" },
  lv: { name_english: "Latvian", name_native: "Latviešu" },
  lt: { name_english: "Lithuanian", name_native: "Lietuvių" },
  mk: { name_english: "Macedonian (FYROM)", name_native: "Македонски" },
  ml: { name_english: "Malayalam", name_native: "മലയാളം" },
  ms: { name_english: "Malaysian", name_native: "Bahasa Malaysia" },
  mt: { name_english: "Maltese", name_native: "Malti" },
  no: { name_english: "Norwegian", name_native: "Norsk" },
  nb: { name_english: "Norwegian (Bokmål)", name_native: "Norsk (Bokmål)" },
  nn: { name_english: "Norwegian (Nynorsk)", name_native: "Norsk (Nynorsk)" },
  pl: { name_english: "Polish", name_native: "Polski" },
  "pt-BR": {
    name_english: "Portuguese (Brazil)",
    name_native: "Português (Brasil)",
  },
  pt: {
    name_english: "Portuguese (Portugal)",
    name_native: "Português (Portugal)",
  },
  pa: { name_english: "Punjabi", name_native: "ਪੰਜਾਬੀ" },
  rm: { name_english: "Rhaeto-Romanic", name_native: "Rumantsch" },
  ro: { name_english: "Romanian", name_native: "Română" },
  "ro-MD": {
    name_english: "Romanian (Republic of Moldova)",
    name_native: "Română (Republica Moldova)",
  },
  ru: { name_english: "Russian", name_native: "Русский" },
  "ru-MD": {
    name_english: "Russian (Republic of Moldova)",
    name_native: "Русский (Республика Молдова)",
  },
  sr: { name_english: "Serbian", name_native: "Српски" },
  sk: { name_english: "Slovak", name_native: "Slovenčina" },
  sl: { name_english: "Slovenian", name_native: "Slovenščina" },
  sb: { name_english: "Sorbian", name_native: "Serbšćina" },
  "es-AR": {
    name_english: "Spanish (Argentina)",
    name_native: "Español (Argentina)",
  },
  "es-BO": {
    name_english: "Spanish (Bolivia)",
    name_native: "Español (Bolivia)",
  },
  "es-CL": { name_english: "Spanish (Chile)", name_native: "Español (Chile)" },
  "es-CO": {
    name_english: "Spanish (Colombia)",
    name_native: "Español (Colombia)",
  },
  "es-CR": {
    name_english: "Spanish (Costa Rica)",
    name_native: "Español (Costa Rica)",
  },
  "es-DO": {
    name_english: "Spanish (Dominican Republic)",
    name_native: "Español (República Dominicana)",
  },
  "es-EC": {
    name_english: "Spanish (Ecuador)",
    name_native: "Español (Ecuador)",
  },
  "es-SV": {
    name_english: "Spanish (El Salvador)",
    name_native: "Español (El Salvador)",
  },
  "es-GT": {
    name_english: "Spanish (Guatemala)",
    name_native: "Español (Guatemala)",
  },
  "es-HN": {
    name_english: "Spanish (Honduras)",
    name_native: "Español (Honduras)",
  },
  "es-MX": {
    name_english: "Spanish (Mexico)",
    name_native: "Español (México)",
  },
  "es-NI": {
    name_english: "Spanish (Nicaragua)",
    name_native: "Español (Nicaragua)",
  },
  "es-PA": {
    name_english: "Spanish (Panama)",
    name_native: "Español (Panamá)",
  },
  "es-PY": {
    name_english: "Spanish (Paraguay)",
    name_native: "Español (Paraguay)",
  },
  "es-PE": { name_english: "Spanish (Peru)", name_native: "Español (Perú)" },
  "es-PR": {
    name_english: "Spanish (Puerto Rico)",
    name_native: "Español (Puerto Rico)",
  },
  es: { name_english: "Spanish (Spain)", name_native: "Español (España)" },
  "es-UY": {
    name_english: "Spanish (Uruguay)",
    name_native: "Español (Uruguay)",
  },
  "es-VE": {
    name_english: "Spanish (Venezuela)",
    name_native: "Español (Venezuela)",
  },
  sv: { name_english: "Swedish", name_native: "Svenska" },
  "sv-FI": {
    name_english: "Swedish (Finland)",
    name_native: "Svenska (Finland)",
  },
  th: { name_english: "Thai", name_native: "ไทย" },
  ts: { name_english: "Tsonga", name_native: "Xitsonga" },
  tn: { name_english: "Tswana", name_native: "Setswana" },
  tr: { name_english: "Turkish", name_native: "Türkçe" },
  uk: { name_english: "Ukrainian", name_native: "Українська" },
  ur: { name_english: "Urdu", name_native: "اردو" },
  ve: { name_english: "Venda", name_native: "Tshivenḓa" },
  vi: { name_english: "Vietnamese", name_native: "Tiếng Việt" },
  cy: { name_english: "Welsh", name_native: "Cymraeg" },
  xh: { name_english: "Xhosa", name_native: "isiXhosa" },
  ji: { name_english: "Yiddish", name_native: "ייִדיש" },
  zu: { name_english: "Zulu", name_native: "isiZulu" },
};
